import { NgModule } from '@angular/core';

import { CapitalizePipe } from '../core/pipes/capitalize.pipe';
import { EffectiveCapacityPipe } from '../core/pipes/effectiveCapacity.pipe';
import { FormatDatePipe } from '../core/pipes/formatDate.pipe';
import { FormatSlotPipe } from '../core/pipes/formatSlot.pipe';
import { IntPhonePipe } from '../core/pipes/intPhone.pipe';
@NgModule({
	imports: [],
	declarations: [CapitalizePipe, IntPhonePipe, FormatDatePipe, FormatSlotPipe, EffectiveCapacityPipe],
	exports: [CapitalizePipe, FormatDatePipe, FormatSlotPipe, IntPhonePipe, EffectiveCapacityPipe],
})
export class PipeModule {}
